import { Route } from "found";
import React from "react";

import Cgu from "./screen/Cgu";

export const routes = (
  <Route path="cgu" Component={Cgu}></Route>
);